export const SocialTypeOpts = [
    { name: "X", value: "x" },
    { name: "Instagram", value: "Instagram" },
    { name: "Facebook", value: "Facebook" },
    { name: "Tiktok", value: "Tiktok" },
    { name: "Spotify", value: "Spotify" },
    { name: "Apple Music", value: "appleMusic" },
    { name: "Youtube", value: "Youtube" },
    { name: "Soundcloud", value: "Soundcloud" },
]

export const YesNoOptions = [
    { name: "Yes", value: true },
    { name: "No", value: false }
]